<template>
  <div style="background: white;position: absolute;margin: auto;top: 0; left: 0; bottom: 0; right: 0;">
    <el-form :model="formData" ref="vForm" label-position="left" label-width="100px"
             size="default" @submit.native.prevent>
      <el-row>
        <el-col :span="24" class="grid-cell">
          <div class="block">
            <el-image
                style="width: 100%"
                :src="require('@/assets/images/user-payment-success-logo.png')">
              <div slot="error" class="image-slot">
<!--                <h1 style="color:red;">老铁加载失败了...</h1>-->
              </div>
            </el-image>
          </div>
        </el-col>
      </el-row>
    </el-form>
<!--    <el-row>-->
<!--      <el-button type="primary" @click="$refs.iframe.style.display='none'">dqdwqdqwdwq</el-button>-->
<!--      <el-button type="primary" @click="isPaymentSuccess">主要按钮</el-button>-->
<!--      <el-button type="text" class="cancel" @click="$refs.recharge_order.onClosePay888()">关 闭</el-button>-->
<!--    </el-row>-->
<!--    <h1>支付成功{{is}}</h1>-->
<!--    <recharge_order ref="recharge_order" style="display: none;"></recharge_order>-->
<!--    <a href="https://home.firefoxchina.cn/?from=extra_start">ggggg</a>-->
  </div>
</template>

<script>
import recharge_order from './rechargeOrder.vue'
export default {
  name: "paymentSuccess",
  // eslint-disable-next-line vue/no-unused-components
  components: { recharge_order },
  data() {
    return {
      is:this.$route.params.is,
    };
    },
  computed: {},
  methods: {
    isPaymentSuccess (){
      //console.log('dqbudqwndqikdq')
      this.packOff = false
      // this.$refs.table.refresh()
      // this.is=this.$route.params.is
    }
  },
};
</script>

<style scoped>

</style>
